
import { Component, Watch } from 'vue-property-decorator';

import Booking from '@/views/Booking.vue';

import ActionsFilterCard from '@/components/activities/FilterCard.vue';

import { BookingsApi } from '@/api/BookingsApi';

import { MetaInfo } from 'vue-meta';

import { find, first, mapValues, sortBy } from 'lodash';

import { findColor, findDate } from '@/config/functions';

import { defaultColors } from '@/config/functions';
import { mapGetters, mapState } from 'vuex';
import { SupplierResponse } from '@/interfaces/Suppliers';

@Component({
   metaInfo(): MetaInfo {
      return {
         title: 'Activities list',
      };
   },
   computed: {
      ...mapState({
         activities: (s: any) => s.activities.items,
         //suppliers: (s: any) => s.activities.suppliers,
         guides: (s: any) => s.activities.guides,
         transfers: (s: any) => s.activities.drivers,
      }),
   },
   components: {
      ActionsFilterCard,
   },
})
export default class Activities extends Booking {
   activities!: any[];

   guides!: any[];

   transfers!: any[];

   stripos!: any;

   default_colors!: any;

   addColorTooltips!: any;

   activities_colors!: any[];

   payment_colors!: any[];

   customFormatter!: any;

   formatterDate!: any;

   formatTime!: any;

   seen: any = {
      suppliers: false,
      transfers: false,
      guides: false,
   };

   group_colors: string[] = defaultColors;

   fields: any[] = [];

   rooms: any[] = [];

   orders: any[] = [];

   filtered: any[] = [];

   dateRange: Date[] = [];

   filter: any = {
      ...this.default_colors,

      act_status: '#ffffff',
      transfer_status: '#ffffff',
      guide_status: '#ffffff',

      o_group_color: '#FEFEFE',
      act_patment_status: '#ffffff',

      types: 0,

      activities: [],
      activity_search: '',

      suppliers: [],
      supplier_search: '',

      transfers: [],
      transfers_search: '',

      guides: [],
      guides_search: '',
      act_day: '',
      act_cost: '',
      transfer_name: '',
      guide_notes: '',
      suplier_notes: '',
   };

   created(): void {
      const $start = this.$moment(this.$localStorage.getItem(this.$route.name + '.startDate'));
      const $end = this.$moment(this.$localStorage.getItem(this.$route.name + '.endDate'));

      this.dateRange = [
         $start.isValid() ? $start.toDate() : this.$moment().toDate(),
         $end.isValid()
            ? $end.toDate()
            : this.$moment()
                 .add(30, 'd')
                 .toDate(),
      ];

      this.fields = [
         {
            key: 'act_status',
            label: 'ACT STATUS',
            thAttr: {
               style: 'width: 43px;',
            },
         },
         {
            key: 'o_group_color',
            label: 'group color',
            thAttr: {
               style: 'width: 43px;',
            },
         },
         {
            key: 'moto_lead_guest',
            sortable: true,
            label: 'lead guest',
         },
         {
            key: 'o_agent.o_nick',
            sortable: true,
            label: 'agent',
            thAttr: {
               style: 'width: 20px;',
            },
         },
         {
            key: 'moto_our_reference',
            sortable: true,
            label: 'OUR REF NR.',
            thAttr: {
               style: 'width: 43px;',
            },
         },
         {
            key: 'act_name',
            sortable: true,
            label: 'activity',
         },
         {
            key: 'supplier_id',
            sortable: true,
            label: 'Activity Supplier',
            thAttr: {
               style: 'width: 50px;',
            },
            formatter: (value: number) => this.supplierName(value),
         },
         {
            key: 'activity_day',
            sortable: true,
            label: 'Activity date',
            thAttr: {
               style: 'width: 70px;',
            },
            formatter: (value: number) => (value ? this.$moment(value).format('DD.MM.YYYY') : ''),
         },
         {
            key: 'act_pax',
            sortable: true,
            label: 'pax',
            thAttr: {
               style: 'width: 50px;',
            },
         },
         {
            key: 'act_pickup_time',
            sortable: true,
            label: 'pickup time',
            thAttr: {
               style: 'width: 65px;',
            },
            formatter: (value: number) => (value ? this.formatTime(value) : ''),
         },
         {
            key: 'act_time',
            sortable: true,
            label: 'Activity Start time',
            thAttr: {
               style: 'width: 65px;',
            },
            formatter: (value: number) => (value ? this.formatTime(value) : ''),
         },
         {
            key: 'transfer_status',
            label: 'Transf. status',
            thAttr: {
               style: 'width: 23px;',
            },
         },
         {
            key: 'transfer_name',
            sortable: false,
            label: 'transfer',
            thAttr: {
               style: 'width: 150px',
            },
            formatter: (id: number) => first(this.transfers.filter(d => d.o_id == id))?.o_name,
         },
         {
            key: 'transfer_notes',
            sortable: true,
            label: 'Transfer notes (group)',
            thAttr: {
               style: 'max-width: 300px;',
            },
         },
         {
            key: 'o_stay_in.o_name',
            sortable: true,
            label: 'stay in',
            formatter(value: string, key: string, item: any) {
               const data = [value];

               if (item['o_stay_in'] != 161785) {
                  data.push(item['o_stay_in.o_hotel.o_hotaddress']);
               } else {
                  data.push(item['o_self_arranged_notes']);
               }

               return data.filter(d => d).join('<br />');
            },
         },
         {
            key: 'guide_status',
            label: 'Guide status',
            thAttr: {
               style: 'width: 23px;',
            },
         },
         {
            key: 'guide_name',
            label: 'Guide',
            thAttr: {
               style: 'width: 150px',
            },
         },
         {
            key: 'guide_notes',
            sortable: false,
            label: 'guide notes',
         },
         {
            key: 'suplier_notes',
            sortable: false,
            label: 'supplier notes',
            thAttr: {
               style: 'width: 150px',
            },
         },
         {
            key: 'act_cost',
            sortable: true,
            label: 'activity cost',
            thAttr: {
               style: 'width: 50px;',
            },
         },
         {
            key: 'act_patment_status',
            sortable: false,
            label: 'payment status',
         },
      ];

      this.filter = {
         ...this.filter,
         ...mapValues(this.$route.query, (val: string) => {
            const value = val.split(';');
            return value.length == 1 ? first(value) : value;
         }),
      };
   }

   filterData() {
      const filter = {
         ...this.default_colors,
         moto_lead_guest: '',
         act_pax: '',
         moto_our_reference: '',
         o_activity_gp: '',
         o_total_gp: '',
         'o_agent.o_nick': '',
         act_name: '',
         act_day: '',
         act_pickup_time: '',
         transfer_name: '',
         transfer_notes: '',
         guide_name: '',
         guide_notes: '',
         suplier_notes: '',
         'o_stay_in.o_name': '',
         ...this.filter,
      };

      //console.log(filter);

      this.filtered = sortBy(
         this.orders.filter(a => {
            const driver = first(this.transfers.filter(g => g.o_id == a.transfer_name));
            const giude = first(this.guides.filter(g => g.o_name == a.guide_name));
            const supplierName = this.supplierName(a.supplier_id);

            const filtered: any = {
               o_group_color: findColor(filter['o_group_color'], a.o_group_color, this.default_colors.o_group_color, this.group_colors),
               act_patment_status: findColor(
                  filter['act_patment_status'],
                  a.act_patment_status,
                  this.default_colors.act_patment_status,
                  this.payment_colors
               ),

               suppliers: !filter['suppliers'].length || filter['suppliers'].includes(a.supplier_id),
               activities: !filter['activities'].length || filter['activities'].includes(a.act_id),
               transfers: !filter['transfers'].length || filter['transfers'].includes(a.transfer_name),
               guides: !filter['guides'].length || filter['guides'].includes(a.guide_id),

               types: (filter['types'] !== 3 || a.guide_name > 0) && (filter['types'] !== 4 || a.transfer_name > 0),

               transfer_name: filter['transfer_name'] === '' || this.stripos(driver?.o_name, filter['transfer_name']),
               supplier_id: filter['supplier_id'] === '' || this.stripos(supplierName, filter['supplier_id']),
               guide_name: filter['guide_name'] === '' || this.stripos(giude?.o_name, a.guide_name),

               act_day: findDate(filter['act_day'], a.act_day),
            };

            //console.log(filter['o_group_color'], a.o_group_color, filtered['o_group_color']);

            for (const f of Object.keys(filter)) {
               if (!a[f] || Object.keys(filtered).includes(f)) continue;

               if (f.indexOf('_status') >= 0 || f.indexOf('_color') >= 0) {
                  filtered[f] = !filter[f].length || findColor(filter[f], a[f], this.default_colors[f], this.activities_colors);
                  continue;
               }

               filtered[f] = filter[f] === '' || this.stripos(a[f], filter[f]);
            }

            return Object.keys(filtered).length == Object.values(filtered).filter(f => f).length;
         }),
         ['activity_day']
      );
   }

   selectActivityType(column: string) {
      let seenObj = this.seen;
      Object.keys(this.seen).map(key => {
         key != column ? (seenObj[key] = false) : (seenObj[key] = true);
      });
   }

   shareActivity(id: string, type: string) {
      if (!this.dateRange[0] || !this.dateRange[1]) return;

      const query: any = { type };

      switch (type) {
         case 'activity':
            query.operationName = find(this.suppliers, { o_uuid: id })?.o_name;
            break;
         case 'transfer':
            query.operationName = find(this.transfers, { o_uuid: id })?.o_name;
            break;
         case 'guide':
            query.operationName = find(this.guides, { o_uuid: id })?.o_name;
            break;
      }

      const routeData = this.$router.resolve({
         name: 'activities.report',
         params: { id },
         query,
      });

      window.open(routeData.href, '_blank');
   }

   notify(type: string) {
      this.$store.commit('showLoading');

      BookingsApi.activitiesList({
         'Booking-SMS': type == 'booking-sms' ? 1 : 0,
         'Notify-E-mail': type == 'email' ? 1 : 0,
         'Notify-SMS': type == 'sms' ? 1 : 0,
         activities: this.filtered.map((item: any) => ({
            id: item.moto_id,
            status: first(this.activities_colors.filter(a => a.d_color_code == item.act_status))?.id,
            o_group_color: item.o_group_color,
            moto_lead_guest: item.moto_lead_guest,
            agent: item['o_agent.o_nick'],
            moto_our_reference: item.moto_our_reference,
            activity: item.act_id,
            activity_date: item.act_day,
            pax: item.act_pax,
            pickup_time: item.act_pickup_time,
            activity_start_time: item.act_time ? item.act_time : '',
            transf_status: item.transfer_status,
            transfer: item.transfer_name,
            transfer_notes_group: item.transfer_notes,
            stay_in: item['o_stay_in.o_name'],
            guide_status: item.guide_status,
            guide: item.guide_name,
            guide_notes: item.guide_notes,
            supplier_notes: item.supplier_notes,
            activity_cost: item.act_cost,
            payment_status: item.act_patment_status ? item.act_patment_status : '',
         })),
      })
         .then(response => {
            if (response.body) {
               this.$bvToast.toast(response.body, {
                  title: 'Success',
                  variant: 'success',
                  solid: true,
               });
            }
         })
         .finally(() => {
            this.$store.commit('hideLoading');
         });
   }

   findOrders() {
      if (!this.dateRange[0] || !this.dateRange[1]) return;

      this.$store.commit('showLoading');
      this.$store.commit('setItems', { name: 'ready', value: false });

      BookingsApi.orderList({
         dateFrom: this.$moment(this.dateRange[0]).format('YYYY-MM-DD'),
         dateTo: this.$moment(this.dateRange[1]).format('YYYY-MM-DD'),
         archive: this.$route.name == 'archive' || this.filter['types'] == 5 ? 1 : 0,
      })
         .then((orders: any[]) => {
            this.orders = orders.map((order: any) => this.formatOrder(order));

            this.addColorTooltips(['.orders-list'], this.activities_colors);
            this.addColorTooltips(['.orders-list'], this.payment_colors, 'pay');
         })
         .finally(() => {
            this.$store.commit('setItems', { name: 'ready', value: true });
            this.$store.commit('hideLoading');
         });
   }

   formatOrder(order: any) {
      const activity_day = order.act_day
         ? this.$moment([this.formatterDate(order.act_day), order.act_time ? this.formatTime(order.act_time) : '00:00:00'].join(' ').trim()).valueOf()
         : null;
      return { ...order, activity_day };
   }

   updateActivityValue(table: string, text: string, field: number, item: any) {
      const order = first(this.orders.filter((o: any) => o.id === item.moto_id));
      const index = item.activity.index;

      order[table][index][field] = text;

      this.$store.commit('showLoading');

      // @ts-ignore
      BookingsApi.saveOrder(order.id, { o_id: order.id, [table]: order[table] })
         .then((result: any) => {
            this.orders = this.orders.map((obj: any) => (obj.o_id === result.o_id ? this.formatOrder(result) : obj));
         })
         .finally(() => {
            this.$store.commit('hideLoading');
         });
   }

   changePaymentStatus($event: any, item: any) {
      item.act_patment_status = first(this.payment_colors.filter(a => a.d_color_code == $event))?.id;

      BookingsApi.changePaymentStatus({
         group_id: item.moto_id,
         activity_id: item.act_id,
         act_date: this.formatterDate(item.act_day),
         act_time: this.formatTime(item.act_time),
         payment_status: item.act_patment_status,
      });
   }

   @Watch('$route', { immediate: false, deep: true })
   onRoute(n: any, o: any) {
      if (n.name !== o.name) {
         this.findOrders();
      }
   }

   @Watch('dateRange', { immediate: false, deep: true })
   onChangeDateRange(n: string[], o: string[]) {
      const nn = n.map(d => this.$moment(d).format('YYYY-MM-DD'));
      const oo = o.map(d => this.$moment(d).format('YYYY-MM-DD'));

      if (nn.length && JSON.stringify(nn) !== JSON.stringify(oo)) {
         this.$localStorage.setItem(this.$route.name + '.startDate', n[0]);
         this.$localStorage.setItem(this.$route.name + '.endDate', n[1]);
         this.findOrders();
      }
   }

   @Watch('orders')
   changeOrders() {
      this.filterData();
   }

   @Watch('filter.types')
   changeFilterTypes(n: number, o: number) {
      if (n == 5 && o !== 5) {
         this.findOrders();
      } else {
         this.changeOrders();
      }
   }

   @Watch('filter', { immediate: true, deep: true })
   changeFilter(filter: any) {
      const query = mapValues({ ...this.$route.query, ...filter }, value => {
         return Array.isArray(value) ? value.join(';') : value;
      });

      if (query['act_day'] !== '') {
         query['act_day'] = this.$moment(query['act_day']).format();
      }

      if (query.activities !== undefined) {
         delete query.activities;
      }

      if (query.suppliers !== undefined) {
         delete query.suppliers;
      }

      this.$router.push({ query }).catch(() => {});

      this.filterData();
   }
}
